import usePageTitle from "@ch/helpers/hooks/usePageTitle";
import type {
  TRouteHandle,
  TRouteHandleCrumb,
  TRouteHandleMeta,
} from "@ch/helpers/utils/types";
import type { FC } from "react";
import { type UIMatch, useLocation, useMatches } from "react-router-dom";
import Breadcrumbs from "./Breadcrumbs";

interface PageHeaderProps {
  hideBreadcrumbs?: boolean;
  meta?: TRouteHandleMeta;
  crumb?: TRouteHandleCrumb;
  className?: string;
  hideHeader?: boolean;
}

const PageHeader: FC<PageHeaderProps> = ({
  hideBreadcrumbs = false,
  meta,
  crumb,
  className = "mb-6",
  hideHeader = false,
}) => {
  const location = useLocation();
  const matches = useMatches() as UIMatch<unknown, TRouteHandle>[];

  const matchHandle = matches?.find(
    (match) => match.pathname === location.pathname,
  );

  const { title, pageTitle } = matchHandle?.handle?.meta?.(meta) ?? {};

  usePageTitle(pageTitle ?? title);

  if (hideHeader) {
    return null;
  }

  return (
    <div className={className}>
      <h1>{title}</h1>
      {!hideBreadcrumbs && <Breadcrumbs crumb={crumb} />}
    </div>
  );
};

export default PageHeader;
